// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.5 3 H12.5 C13.6 3 14.5 3.9 14.5 5 V11 C14.5 12.1 13.6 13 12.5 13 H3.5 C2.4 13 1.5 12.1 1.5 11 V5 C1.5 3.9 2.4 3 3.5 3 Z',
  'M1.5 7H14.5',
  'M4.44 4.94H4.56V5.06H4.44Z',
  'M7.19 4.94H7.31V5.06H7.19Z',
];
